<script>
	import Base from '@backend/Base.vue';
	export default {
		name: "BoLegal",
		extends: Base,
		data() {
			return {
				Name: "BoLegal",
			}
		},
		mounted() {
			this.$set(this.$root, 'page', this)
			this.refreshData()
		},
		watch: {
			'$route.query'() {
				this.refreshData()
			},
		},
		methods: {}
	}
</script>

<template>
	<div class="container-fluid">
		<PageTitle></PageTitle>

		<!-- ======================================================================== 
			LIST DATA
		============================================================================= -->
		<div class="row" v-if="!$route.params.id">
			<div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
				<div class="card">
					<div class="card-body">
						<VForm @resp="search">
							<div class="row">
								<div class="col-sm-5">
									<h5 class="card-title">{{ObjectName}} List</h5>
								</div>
								<div class="col-sm-3">
								</div>
								<div class="col-sm-3">
									<div class="form-group mb-0">
										<div class="input-group">
											<input type="text" v-model="filter.search" class="form-control"
												placeholder="Search...">
											<div class="input-group-append">
												<button class="btn btn-info" type="button" @click="search()"><i
														class="fas fa-search"></i></button>
											</div>
										</div>
									</div>
								</div>
								<div class="col-sm-1">
									<router-link :to="{name:Name}" class="btn btn-warning">Reset</router-link>
								</div>
							</div>
						</VForm>
					</div>
					<div class="table-responsive ajax-table">
						<table class="table table-striped table-bordered">
							<thead>
								<tr>
									<th>#</th>
									<th>
										<SortField name="asc_title_en"></SortField>
									</th>
									<th>Status</th>
									<th width="120px">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(v,k) in data.data" :key="k">
									<td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
									<td>{{v.asc_title_en}}</td>
									<td>
										<StatusLabel :status="v.status"></StatusLabel>
									</td>
									<td class="btn-action">
										<router-link class="icon_action" :to="{name:Name,params:{id:v.id}}"
											v-tooltip="'Edit'"><i class="ti-marker-alt"></i></router-link>
										<a href="javascript:;" class="icon_action" @click="changeStatus(k)"
											v-tooltip="'Change Status'"><i class="icon-settings"></i></a>
									</td>
								</tr>
								<tr v-if="NotFound">
									<td colspan="99">
										<h3 class="tc">{{NotFound}}</h3>
									</td>
								</tr>
								<tr v-if="data.data===false">
									<td colspan="99">
										<LoadingSpinner light></LoadingSpinner>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="panel-body">
						<div class="pull-right">
							<Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ======================================================================== 
			FORM CRUD	
		============================================================================= -->
		<div class="card" v-if="$route.params.id">
			<VForm @resp="submitForm" method="post">
				<div class="card-body">
					<div class="row mb-3">
						<div class="col-md-8">
							<h5 class="card-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h5>
						</div>
					</div>
					<div class="info"></div>
					<div class="row">
						<div class="col-sm-6">
							<BoField name="asc_title_en" v-model="row.asc_title_en"></BoField>
							<BoField name="asc_desc_en">
								<CKEditor name="asc_desc_en" v-model="row.asc_desc_en"
									v-bind="validation('asc_desc_en')">
								</CKEditor>
							</BoField>
							<BoField name="asc_meta_title_en" v-model="row.asc_meta_title_en"></BoField>
							<BoField name="asc_meta_keyword_en">
								<TagsInput :placeholder="'Add keyword'" name="asc_meta_keyword_en"
									v-model="row.asc_meta_keyword_en" :attr="validation('asc_meta_keyword_en')">
								</TagsInput>
							</BoField>
							<BoField name="asc_meta_desc_en">
								<textarea rows="4" name="asc_excerpt" v-model="row.asc_meta_desc_en"
									v-bind="validation('asc_meta_desc_en')" class="form-control"></textarea>
							</BoField>
							<BoField name="asc_is_active">
								<div class="row">
									<div class="col-2"><radio name="asc_is_active" v-model="row.asc_is_active" option="Y"
										:attr="validation('asc_is_active')">Active</radio></div>
									<div class="col-2"><radio name="asc_is_active" v-model="row.asc_is_active" option="N">Inactive</radio></div>
								</div>
							</BoField>
						</div>
						<div class="col-sm-6">
							<BoField name="asc_title_id" v-model="row.asc_title_id"></BoField>
							<BoField name="asc_desc_id">
								<CKEditor name="asc_desc_id" v-model="row.asc_desc_id"
									v-bind="validation('asc_desc_id')">
								</CKEditor>
							</BoField>
							<BoField name="asc_meta_title_id" v-model="row.asc_meta_title_id"></BoField>
							<BoField name="asc_meta_keyword_id">
								<TagsInput :placeholder="'Add keyword'" name="asc_meta_keyword_id"
									v-model="row.asc_meta_keyword_id" :attr="validation('asc_meta_keyword_id')">
								</TagsInput>
							</BoField>
							<BoField name="asc_meta_desc_id">
								<textarea rows="4" name="asc_excerpt" v-model="row.asc_meta_desc_id"
									v-bind="validation('asc_meta_desc_id')" class="form-control"></textarea>
							</BoField>
						</div>
						<div class="col-12">
							<div class="text-right">
								<button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading btn-rounded">Save Legal</button>
							</div>
						</div>
					</div>
				</div>
			</VForm>
		</div>
	</div>
</template>